import styled from "styled-components";

export const ErrorLabel = styled.p`
  color: ${({ theme }): string => theme.colors.red};
  font-size: 0.875rem;
  margin-top: 0.25rem;
`;

export default ErrorLabel;
